// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aboutUsContainer {
  width: 90%;
  margin: 50px auto auto auto;
  text-align: center;
  display: flex;
  justify-content: center;
}
.faqContainer {
  width: 90%;
  margin: auto;
}
.aboutUsContainer > div {
  width: -moz-fit-content;
  width: fit-content;
}
.aboutUsContainer > div > div {
  background: #206d23;
  position: relative;
  z-index: 1;
  left: -20px;
  top: -30px;
  height: 40px;
  width: calc(85%);
}
.aboutUsContainer > div > label {
  color: #fff;
  font-family: "Inter";
  font-size: clamp(30px, 3vw, 52px) !important;
  font-weight: 600;
  position: relative;
  z-index: 2;
}
.mainFAQ {
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
}
.mainFAQ > div {
  width: 70%;
}

.navbar {
  display: flex;
  width: 100%;
  justify-content: flex-start;
  margin: 50px 0px;
}
.border {
  position: relative;
  bottom: 50px;
  z-index: 1;
  border-bottom: 1px solid #3b3b3b !important;
}
.tabActive {
  text-align: center;
  font-size: clamp(18px, 4vw, 22px);
  font-weight: 700;
  border-bottom: 2px solid #fff;
  padding-bottom: 5px;
  margin-right: 40px;
  font-family: Inter;
  cursor: pointer;
}

.disable {
  color: #cbcbcb;
  text-align: center;
  font-family: Inter;
  cursor: pointer;
  margin-right: 40px;
  font-size: clamp(16px, 4vw, 20px);
  font-weight: 400;
}

.faqData > h1 {
  color: #fff;
  font-family: "Archivo";
  font-size: clamp(18px, 4vw, 32px) !important;
  font-style: normal;
  font-weight: 500 !important;
  line-height: normal;
  text-align: left;
}
.accordianques {
  color: #fff;
  font-family: "Open Sans";
  font-size: clamp(18px, 3vw, 22px) !important;
  font-weight: 400;
  margin-bottom: 0px !important;
}
.accordianans {
  color: #cecece;
  font-family: "Open Sans";
  font-size: clamp(14px, 4vw, 18px) !important;
  font-weight: 400;
}
@media screen and (max-width: 1400px) {
  .mainFAQ > div {
    width: 90%;
  }
}
@media screen and (max-width: 1200px) {
  .mainFAQ > div {
    width: 100%;
  }
}
@media screen and (max-width: 600px) {
  .navbar {
    margin: 10px 0px;
  }
  .border {
    position: relative;
    bottom: 10px;
  }
  .aboutUsContainer > div > div {
    position: relative;
    z-index: 1;
    left: -5px;
    top: -50px;
    height: 35px;
    width: calc(75%);
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/FAQ/faq.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,uBAAkB;EAAlB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,4CAA4C;EAC5C,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,2CAA2C;AAC7C;AACA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,4CAA4C;EAC5C,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,wBAAwB;EACxB,4CAA4C;EAC5C,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,cAAc;EACd,wBAAwB;EACxB,4CAA4C;EAC5C,gBAAgB;AAClB;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,UAAU;IACV,YAAY;IACZ,gBAAgB;EAClB;AACF","sourcesContent":[".aboutUsContainer {\n  width: 90%;\n  margin: 50px auto auto auto;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n}\n.faqContainer {\n  width: 90%;\n  margin: auto;\n}\n.aboutUsContainer > div {\n  width: fit-content;\n}\n.aboutUsContainer > div > div {\n  background: #206d23;\n  position: relative;\n  z-index: 1;\n  left: -20px;\n  top: -30px;\n  height: 40px;\n  width: calc(85%);\n}\n.aboutUsContainer > div > label {\n  color: #fff;\n  font-family: \"Inter\";\n  font-size: clamp(30px, 3vw, 52px) !important;\n  font-weight: 600;\n  position: relative;\n  z-index: 2;\n}\n.mainFAQ {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 40px;\n}\n.mainFAQ > div {\n  width: 70%;\n}\n\n.navbar {\n  display: flex;\n  width: 100%;\n  justify-content: flex-start;\n  margin: 50px 0px;\n}\n.border {\n  position: relative;\n  bottom: 50px;\n  z-index: 1;\n  border-bottom: 1px solid #3b3b3b !important;\n}\n.tabActive {\n  text-align: center;\n  font-size: clamp(18px, 4vw, 22px);\n  font-weight: 700;\n  border-bottom: 2px solid #fff;\n  padding-bottom: 5px;\n  margin-right: 40px;\n  font-family: Inter;\n  cursor: pointer;\n}\n\n.disable {\n  color: #cbcbcb;\n  text-align: center;\n  font-family: Inter;\n  cursor: pointer;\n  margin-right: 40px;\n  font-size: clamp(16px, 4vw, 20px);\n  font-weight: 400;\n}\n\n.faqData > h1 {\n  color: #fff;\n  font-family: \"Archivo\";\n  font-size: clamp(18px, 4vw, 32px) !important;\n  font-style: normal;\n  font-weight: 500 !important;\n  line-height: normal;\n  text-align: left;\n}\n.accordianques {\n  color: #fff;\n  font-family: \"Open Sans\";\n  font-size: clamp(18px, 3vw, 22px) !important;\n  font-weight: 400;\n  margin-bottom: 0px !important;\n}\n.accordianans {\n  color: #cecece;\n  font-family: \"Open Sans\";\n  font-size: clamp(14px, 4vw, 18px) !important;\n  font-weight: 400;\n}\n@media screen and (max-width: 1400px) {\n  .mainFAQ > div {\n    width: 90%;\n  }\n}\n@media screen and (max-width: 1200px) {\n  .mainFAQ > div {\n    width: 100%;\n  }\n}\n@media screen and (max-width: 600px) {\n  .navbar {\n    margin: 10px 0px;\n  }\n  .border {\n    position: relative;\n    bottom: 10px;\n  }\n  .aboutUsContainer > div > div {\n    position: relative;\n    z-index: 1;\n    left: -5px;\n    top: -50px;\n    height: 35px;\n    width: calc(75%);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
